import { TriangleAlert } from 'lucide-react';
import { useCampaignStore } from '@/stores';

/**
 * Persistent DEMO banner (ADR-056). Renders in the app shell for every member of a
 * campaign flagged `isDemo`, so everyone knows the data is disposable. Keyed purely off
 * `selectedCampaign.isDemo` — a platform admin toggling demo mode flips it in-session once
 * the campaign query is invalidated, with no reload.
 */
export function DemoBanner() {
  const selectedCampaign = useCampaignStore((s) => s.selectedCampaign);

  if (!selectedCampaign?.isDemo) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-300 px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium text-amber-900">
      <TriangleAlert className="h-4 w-4" />
      <span>DEMO — data is disposable</span>
    </div>
  );
}
